import React from "react";

class CompletionRing extends React.Component {
	constructor(props) {
		super(props);
		const { radius, stroke } = this.props;
		this.normalizedRadius = radius - stroke * 2;
		this.circumference = this.normalizedRadius * 2 * Math.PI;
	}

	render() {
		const {
			radius,
			stroke,
			progress,
			successColor,
			successPercent,
		} = this.props;
		const strokeDashoffset =
			this.circumference - (progress / 100) * this.circumference;
		return (
			<div className="relative ring-container">
				<svg
					height={radius * 2}
					width={radius * 2}
					style={{ transform: "rotate(-90deg)" }}
				>
					<circle
						stroke={
							progress > (successPercent || 70) || this.props.showSuccessAlways
								? successColor || "#61B204"
								: progress > 40
								? "#f5a623"
								: "#d0021b"
						}
						fill={
							this.props.backgroundColor &&
							(progress === 0 || !this.props.showSuccessAlways)
								? this.props.backgroundColor
								: "#fafafa"
						}
						strokeWidth={stroke}
						strokeDasharray={this.circumference + " " + this.circumference}
						style={{ strokeDashoffset }}
						r={this.normalizedRadius}
						cx={radius}
						cy={radius}
					/>
				</svg>
				{this.props.progressText ? (
					<div
						className="progress-text"
						dangerouslySetInnerHTML={{ __html: this.props.progressText }}
					/>
				) : (
					<span className="progress-text">{this.props.progress}%</span>
				)}
			</div>
		);
	}
}

export default CompletionRing;
